export const EmployerCompanyOptions = [
    {
      'id': 0,
      'handle': 'American Chase',
      'title': 'American Chase',
    },
    {
      'id': 1,
      'handle': 'JumboIT',
      'title': 'JumboIT',
    },
    {
      'id': 2,
      'handle': 'NuQode',
      'title': 'NuQode',
    },
    {
      'id': 3,
      'handle': 'Mindsburg',
      'title': 'Mindsburg',
    },
    {
      'id': 4,
      'handle': 'Asoid Group',
      'title': 'Asoid Group',
    },{
      'id': 5,
      'handle': 'Other',
      'title': 'Other',
      },
]

export const EmployerFilterOptions = [
  {
    'id': 0,
    'handle': 'american_chase',
    'title': 'American Chase',
  },
  {
    'id': 1,
    'handle': 'jumboit',
    'title': 'JumboIT',
  },
  {
    'id': 2,
    'handle': 'nuqode',
    'title': 'NuQode',
  },
  {
    'id': 3,
    'handle': 'mindsburg',
    'title': 'Mindsburg',
  },
  {
    'id': 4,
    'handle': 'asoid_group',
    'title': 'Asoid Group',
  },
  {
    'id': 5,
    'handle': 'all',
    'title': 'All',
  },
  {
    'id': 6,
    'handle': 'other',
    'title': 'Other',
    },
]

export const STATUS_COLORS = {
  Approved: "green",
  Rejected: "#FF0000",
};

export const VisaTypeExpKeys = {
  "usc_copy" : "us_passport_expiry",
  "gc_copy" : "gc_expiry",
  "gc_ead_copy" : "gc_ead_expiry",
  "h4_ead_copy" : "h4_ead_expiry",
  "opt_copy" : "opt_expiry",
  "cpt_copy" : "cpt_expiry",
}
